import React from 'react'
import Grid from '@material-ui/core/Grid'
import MuiTooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import InfoIcon from '@material-ui/icons/Info'

const styles = ({
  spacing,
  breakpoints,
  fontSize,
  palette: { gray, error },
  fontWeight,
  palette,
}) => ({
  fullWrapper: {
    paddingBottom: spacing(2),
  },
  wrapper: {
    paddingBottom: spacing(2),
  },
  requiredDot: {
    color: `#0B2D48`,
    fontSize: `1em`,
    marginLeft: 2,
    top: 0,
  },
  opcional: {
    fontSize: `1.4rem`,
    fontWeigth: 100,
    fontStyle: `italic`,
    marginLeft: 6,
  },
  paddingRight: {
    paddingRight: spacing(1),
    textAlign: `right`,
    [breakpoints.down(`sm`)]: {
      textAlign: `left`,
    },
  },
  error: {
    paddingTop: spacing(1),
    color: error.main,
    fontSize: fontSize[1],
    width: `100%`,
  },
  errorColor: {
    color: error.main,
  },
  checkbox: {
    color: gray.main,
    marginTop: `5px`,
  },
  positionLabelWrapper: {
    flexDirection: `row-reverse`,
    justifyContent: `flex-end`,
    alignItems: `center`,
    // marginBottom: spacing(2),
  },
  positionLabelWrapperPadding: {
    paddingLeft: spacing(3),
    paddingRight: spacing(3),
    marginBottom: spacing(2),
  },
  disabled: {
    // opacity: 0.6,
    color: `#525E6D`,
  },
  positionLabel: {
    flexBasis: `auto`,
  },
  subLabel: {
    fontSize: fontSize[0],
    lineHeight: `1rem`,
    fontWeight: fontWeight[0],
  },
  check: {
    margin: 0,
    padding: 0,
    justifyContent: `flex-start`,
  },
  checkLabel: {
    width: `auto`,
    paddingLeft: spacing(1),
    paddingBottom: 0,
  },
  label: {
    color: palette.gray[3],
    fontWeight: fontWeight[0],
  },
  borderTop: {
    borderTop: `1px solid ${gray.main}`,
    paddingTop: spacing(3),
  },
  cursorPointer: {
    '&:hover': {
      cursor: `pointer`,
    },
  },
  checkboxInput: {
    width: `auto`,
  },
  regularLabel: {
    paddingBottom: spacing(1),
  },
  tooltipIcon: {
    marginLeft: spacing(1),
    fill: `#c2c9d6`,
  },
  extraPadding: {
    padding: spacing(2, 0),
  },
  tooltip: {
    fontSize: fontSize[0],
  },
})

const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: `black`,
    '& > *': {
      color: `white !important`,
    },
  },
}))(MuiTooltip)

function Label({
  children,
  error = false, //Puede ser boolean o string
  label,
  subLabel = ``,
  classes,
  disabled = false,
  positionLabel = `left`,
  flexDirection = `row`,
  borderTop = false,
  inlineLabel = false,
  tooltip = false,
  footer = ``,
  fullWidth = false,
  withPadding = false,
  checkbox = false,
  multiLabel = false,
  languageKey = null,
  type = ``,
  md = 12,
  xs = 12,
  isRequired = false,
  tooltip_chk=false
}) {
 
  return (
    <Grid
      item
      container
      xs={xs}
      md={md}
      alignContent="flex-start"
      className={`${error && `has-warning`} ${borderTop && classes.borderTop} ${
        fullWidth ? classes.fullWrapper : classes.wrapper
      } ${withPadding ? classes.extraPadding : ``}`}
    >
      <>
        <Grid
          container
          direction={flexDirection}
          alignItems="center"
          alignContent="flex-start"
          xs={12}
          item
          spacing={inlineLabel ? 4 : 0}
          className={`${positionLabel === `right` && classes.positionLabelWrapper} ${disabled &&
            classes.disabled}`}
        >
          {label && (
            <Grid className={checkbox ? classes.checkLabel : classes.regularLabel}>
              <Typography
                variant="h3"
                color="primary"
                className={`${error ? classes.errorColor : ``} ${classes.label} titulos-input`}
                dangerouslySetInnerHTML={{
                  __html: `${isRequired ? `<span style="color:red;">* </span>` : ``}${
                    multiLabel ? label[languageKey] : label
                  }`,
                }}
              />
            </Grid>
          )}
         
          {tooltip && (
            <Grid item xs={1} md={1} className={classes.cursorPointer}>
              <Tooltip
                title={
                  <Typography
                    variant="body1"
                    className={classes.tooltip}
                    dangerouslySetInnerHTML={{ __html: tooltip }}
                  />
                }
                placement="top"
                arrow
              >
                <InfoIcon className={classes.tooltipIcon} />
              </Tooltip>
            </Grid>
          )}
          <Grid
            container
            className={`${
              checkbox
                ? classes.checkboxInput
                : positionLabel === `right`
                ? classes.positionLabel
                : ``
            }`}
          >
            {subLabel && (
              <Typography variant="h6" className={classes.subLabel}>
                {subLabel}
              </Typography>
            )}
            {children}
            {footer && (
              <Typography variant="h6" className={classes.subLabel}>
                {footer}
              </Typography>
            )}
          </Grid>
          {error && typeof error === 'object' && Object.keys(error).length > 0 ? (
              // Si error es un objeto con claves, maneja el error apropiadamente.
              <Typography variant="h6" className={classes.error}>
                {/* Renderiza un mensaje de error genérico o personalizado */}
                {error["es"]}
              </Typography>
            ) : (
              // Si error no es un objeto o es una cadena vacía, renderiza el error normalmente.
              <Typography variant="h6" className={classes.error}>
                {error}
              </Typography>
            )}
        </Grid>
      </>
    </Grid>
  )
}

export default withStyles(styles)(Label)
